import type { SiteCartSnapshot, SiteCartLine } from '~/lib/site-catalog'
import { emptySiteCart } from '~/lib/site-catalog'

/** Снимок из props страницы /cart (items + total с контроллера) */
export function pageCartFromProps(props: Record<string, unknown>): SiteCartSnapshot | null {
  const items = props.items as SiteCartLine[] | undefined
  const total = props.total as number | undefined
  if (!items?.length) {
    return null
  }

  const count = items.reduce((sum, item) => sum + item.quantity, 0)
  return {
    count,
    total: total ?? items.reduce((sum, item) => sum + item.lineTotal, 0),
    items,
  }
}

/** Серверная корзина: shared siteCart или props страницы /cart */
export function readServerSiteCart(props: Record<string, unknown>): SiteCartSnapshot {
  const shared = props.siteCart as SiteCartSnapshot | undefined
  if (shared && shared.count > 0) {
    return shared
  }

  return pageCartFromProps(props) ?? emptySiteCart()
}

/** Локальный store (после действий) или данные с сервера */
export function resolveSiteCart(
  local: SiteCartSnapshot,
  props: Record<string, unknown>
): SiteCartSnapshot {
  if (local.count > 0) {
    return local
  }

  return readServerSiteCart(props)
}

export function lineQtyFromCart(cart: SiteCartSnapshot, productId: number): number {
  return cart.items.find((item) => item.productId === productId)?.quantity ?? 0
}
